<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import appConf from '../../app.conf';
    import { openBigImgDlg } from '../comn/dialog'

    import devcDefApi from '../../api/devcDef'

    import SwbMerchtDevcAsset from '../devcDef/MerchtDevcAsset';
    Vue.regist(SwbMerchtDevcAsset);
    import SwbAsmblAccDefList from '../asmblAcc/AsmblAccDefList';
    Vue.regist(SwbAsmblAccDefList);

    export default {
        name: 'swb-mercht-devc-acc-asmbl-rel-list',
        desc: '组装件列表',
        props: {
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            activeName: null,
        },
        watch: {
            activeName: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    this.getDataList();
                }
            }
        },
        data: function () {
            return {
                //
                confKey: 'swb-mercht-devc-acc-asmbl-rel-list',
                theTableHeight: 450,
                //
                needPager: false, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                asmblAccIoTypeMap: {}
            }
        },
        created: function () {
            this.asmblAccIoTypeMap = getEnumMap('asmblAccIoType', 'value2text');
        },
        mounted() {
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onQueryConfigReady: function () {
                this.initAsyncQueryModel();
            },
            initAsyncQueryModel() {
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.imageUrl)) {
                            return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        } else {
                            return "";
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        if(!row.disabled) {
                            return '<a name="set_adopted_device" class="swb-btn swb-btn-link">查看</a>';
                        }
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(row.imageUrl);
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'set_adopted_device') {
                            self.toSetAdoptedDevice(row);
                        }
                    }
                });
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getDataList();
            },
            //
            renderTable(rows) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows
                };

                resultTable.render(tableData);
            },
            getDataList(){
                let self = this;
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                filterItems = Object.assign(filterItems, self.filter);
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                devcDefApi.getAsmblAccDefList(filterItems, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        self.renderTable(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 资产商品
            toSetAdoptedDevice(row) {
                // 查看条件
                let url = SwbAsmblAccDefList.path;
                let hashUrl = Utils.makeUrl(url, {id: row.id});
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/asmblAcc/MerchtDevcAccAsmblRelList.vue